import { weijuHero } from '@/mocks/weiju';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      {/* 背景：暖色餐饮场景 + 金色光带 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20upscale%20restaurant%20gathering%20scene%20at%20golden%20evening%2C%20friends%20sharing%20a%20meal%20around%20a%20table%20with%20soft%20amber%20ambient%20lighting%20and%20subtle%20flowing%20light%20ribbons%2C%20deep%20charcoal%20and%20warm%20gold%20tones%2C%20elegant%20dining%20atmosphere%2C%20understated%20editorial%20photography%2C%20high%20detail%2C%20cinematic%20but%20restrained%20lighting%2C%20harmonious%20composition&width=1600&height=900&seq=weiju-hero-bg-01&orientation=landscape"
          alt="敬龙国际味聚项目"
          title="味聚 · 餐饮消费与供应链数字化服务平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/88 to-foreground-950/55"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-transparent to-foreground-950/70"></div>
      </div>

      {/* 低对比装饰光晕（暖金 / 生态绿，克制） */}
      <div className="absolute -top-20 -right-20 w-72 h-72 md:w-96 md:h-96 rounded-full bg-secondary-500/10 blur-3xl animate-float-slow pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 md:w-[28rem] md:h-[28rem] rounded-full bg-accent-500/10 blur-3xl animate-float-slow pointer-events-none" style={{ animationDelay: '2s' }}></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-32 pb-20 md:pt-40 md:pb-24 min-h-[620px] md:min-h-[720px] flex items-center">
        <div className="max-w-7xl mx-auto w-full">
          {/* 文案 */}
          <div className="w-full max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 backdrop-blur">
              <span className="w-2 h-2 rounded-full bg-secondary-400"></span>
              <span className="text-xs md:text-sm text-background-100 tracking-wide whitespace-nowrap">
                {weijuHero.eyebrow}
              </span>
            </div>

            <h1 className="mt-6 font-heading font-bold text-background-50 leading-tight">
              <span className="block text-4xl md:text-6xl">{weijuHero.title}</span>
              <span className="block mt-3 text-2xl md:text-4xl text-secondary-300">
                {weijuHero.titleHighlight}
              </span>
            </h1>

            <p className="mt-6 text-xs md:text-sm text-foreground-400 leading-relaxed max-w-xl">
              {weijuHero.note}
            </p>

            <div className="mt-8 flex flex-wrap gap-2">
              {weijuHero.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full text-xs text-background-100 bg-background-50/10 border border-background-50/15 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}